import { sharedEventEmitter } from "../../utils/sharedEvents";
//custom action for checking whether context widget is part of the corporate site
export function openCookiesPanel() {
    return () => {
        sharedEventEmitter.emit("open-consent-modal", { expanded: true });
    };
}
